import {
	LOGIN_FB,
	LOGIN_GM,
	LOGIN_LN,
	LOGIN_LOCAL,
	LOGOUT_LOCAL,
	SIGNUP_USER,
	RESTORE_SESSION,
	NEWPASSWORD_REQ,
	FORGOT_PASSWORD,
	RESET_PASSWORD,
	RESEND_VARIFICATION,
	UPDATE_USER_ATTRIBS,
	ADD_USER_OBJECTS,
	CHANGE_PASSWORD,
	GET_USER,
	CREATE_USER,
	UPDATE_USER,
	UPLOAD_PROFILE_IMAGE,
	FAVORITE_PROJECT,
	FOLLOW_USER,
	WRITE_RATING,
	GET_RATING,
	UPDATE_RATING,
	SEND_EMAIL,
	UPDATE_LATEST_LOGIN
} from "../ActionTypes"
import {
	profileImageValidator,
	givenNameFamilyNameValidator
} from "../FunctionAction/function.user"
const initialState = {
	user: {},
	userInfo: {
		user_id: "",
		email: "",
		given_name: "",
		family_name: "",
		image: ""
	},
	objects: {},
	finishfb: false,
	finishgm: false,
	finishln: false,
	finishlocal: false,
	finish: false,
	finishimage: false,
	rating: []
}

export default function (state = initialState, { type, payload }) {
	switch (type) {
		case SIGNUP_USER + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case SIGNUP_USER + "_PENDING":
			return {
				...state,
				finish: true
			}
		case SIGNUP_USER + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case LOGIN_FB + "_FULFILLED":
			return {
				...state,
				userInfo: {
					user_id: payload.result.id,
					email: payload.result.email,
					given_name: payload.result.first_name,
					family_name: payload.result.last_name,
					image: payload.result.picture.data.url
				},
				user: payload.response,
				finishfb: false
			}
		case LOGIN_FB + "_PENDING":
			return {
				...state,
				finishfb: true
			}
		case LOGIN_FB + "_REJECTED":
			return {
				...state,
				user: {},
				userInfo: {},
				finishfb: false
			}
		case LOGIN_GM + "_FULFILLED":
			return {
				...state,
				userInfo: {
					user_id: payload.result.id,
					email: payload.result.email,
					given_name: payload.result.given_name,
					family_name: payload.result.family_name,
					image: payload.result.image
				},
				user: payload.response,
				finishgm: false
			}
		case LOGIN_GM + "_PENDING":
			return {
				...state,
				finishgm: true
			}
		case LOGIN_GM + "_REJECTED":
			return {
				...state,
				user: {},
				userInfo: {},
				finishgm: false
			}
		case LOGIN_LN + "_FULFILLED":
			return {
				...state,
				userInfo: {
					user_id: payload.result.id,
					email: payload.result.email,
					given_name: payload.result.given_name,
					family_name: payload.result.family_name,
					image: payload.result.picture
				},
				user: payload.response,
				finishln: false
			}
		case LOGIN_LN + "_PENDING":
			return {
				...state,
				finishln: true
			}
		case LOGIN_LN + "_REJECTED":
			return {
				...state,
				user: {},
				userInfo: {},
				finishln: false
			}
		case LOGIN_LOCAL + "_FULFILLED":
			if (payload === "NEW_PASSWORD_REQUIRED") {
				return {
					...state,
					user: {},
					userInfo: {},
					finishlocal: false
				}
			} else {
				let userInfo = {
					...payload.result.cognitoUser.attributes,
					user_id: payload.result.Credentials.data.IdentityId
				}
				return {
					...state,
					user: payload.result.Credentials,
					userInfo,
					finishlocal: false
				}
			}

		case ADD_USER_OBJECTS + "_FULFILLED":
			return {
				...state,
				objects: payload.objects
			}
		case LOGIN_LOCAL + "_PENDING":
			return {
				...state,
				finishlocal: true
			}
		case LOGIN_LOCAL + "_REJECTED":
			return {
				...state,
				user: {},
				userInfo: {},
				finishlocal: false
			}
		case LOGOUT_LOCAL + "_FULFILLED":
			return {
				...state,
				user: {},
				userInfo: {},
				finishlocal: false
			}
		case LOGOUT_LOCAL + "_PENDING":
			return {
				...state,
				finishlocal: true
			}
		case LOGOUT_LOCAL + "_REJECTED":
			return {
				...state,
				finishlocal: false
			}
		case RESTORE_SESSION + "_FULFILLED":
			let userInfo = {}
			if (!!payload.result.cognitoUser.attributes) {
				userInfo = {
					...payload.result.cognitoUser.attributes,
					user_id: payload.result.Credentials.data.IdentityId,
					image: profileImageValidator(payload, "restore")
				}
			} else {
				let dataValidator = givenNameFamilyNameValidator(payload, "get_user")
				userInfo = {
					user_id: payload.result.Credentials.data.IdentityId,
					email: payload.result.cognitoUser.email,
					given_name: dataValidator.given_name,
					family_name: dataValidator.family_name,
					image: profileImageValidator(payload, "restore")
				}
			}
			return {
				...state,
				user: payload.result.Credentials,
				userInfo
			}

		case RESTORE_SESSION + "_REJECTED":
			return {
				...state,
				user: {},
				userInfo: {}
			}
		case UPDATE_USER_ATTRIBS + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case UPDATE_USER_ATTRIBS + "_PENDING":
			return {
				...state,
				finish: true
			}
		case UPDATE_USER_ATTRIBS + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case NEWPASSWORD_REQ + "_FULFILLED":
			return {
				...state,
				userInfo: payload.challengeParam.userAttributes,
				user: payload,
				finish: false
			}
		case NEWPASSWORD_REQ + "_PENDING":
			return {
				...state,
				finish: true
			}
		case NEWPASSWORD_REQ + "_REJECTED":
			return {
				...state,
				userInfo: {},
				user: {},
				finish: false
			}
		case FORGOT_PASSWORD + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case FORGOT_PASSWORD + "_PENDING":
			return {
				...state,
				finish: true
			}
		case FORGOT_PASSWORD + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case RESET_PASSWORD + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case RESET_PASSWORD + "_PENDING":
			return {
				...state,
				finish: true
			}
		case RESET_PASSWORD + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case RESEND_VARIFICATION + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case RESEND_VARIFICATION + "_PENDING":
			return {
				...state,
				finish: true
			}
		case RESEND_VARIFICATION + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case CHANGE_PASSWORD + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case CHANGE_PASSWORD + "_PENDING":
			return {
				...state,
				finish: true
			}
		case CHANGE_PASSWORD + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case GET_USER + "_FULFILLED":
			let userinfo = state.userInfo
			if (Object.keys(payload).length !== 0) {
				let dataValidator = givenNameFamilyNameValidator(payload, "get_user")
				userinfo = {
					...payload,
					ip_country: payload.ip_country,
					user_id: payload.user_id,
					email: payload.email,
					given_name: dataValidator.given_name,
					family_name: dataValidator.family_name,
					image: profileImageValidator(payload, "get_user")
				}
				if (!!payload.first_name) {
					delete userinfo.first_name
				}
				if (!!payload.last_name) {
					delete userinfo.last_name
				}
				if (!!payload.profile_picture) {
					delete userinfo.profile_picture
				}
				if (!!payload.role_system) {
					delete userinfo.role_system
				}
			}
			return {
				...state,
				userInfo: userinfo,
				finish: false
			}
		case GET_USER + "_PENDING":
			return {
				...state,
				finish: true
			}
		case GET_USER + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case CREATE_USER + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case CREATE_USER + "_PENDING":
			return {
				...state,
				finish: true
			}
		case CREATE_USER + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case UPDATE_USER + "_FULFILLED":
			payload = payload.data.updateUser[0]
			return {
				...state,
				userInfo: {
					...state.userInfo,
					image: profileImageValidator(payload, "get_user")
				},
				finish: false
			}
		case UPDATE_USER + "_PENDING":
			return {
				...state,
				finish: true
			}
		case UPDATE_USER + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case UPDATE_LATEST_LOGIN + "_FULFILLED":
			return { ...state }
		case UPDATE_LATEST_LOGIN + "_PENDING":
			return { ...state }
		case UPDATE_LATEST_LOGIN + "_REJECTED":
			return { ...state }
		case UPLOAD_PROFILE_IMAGE + "_FULFILLED":
			return { ...state, finishimage: false }
		case UPLOAD_PROFILE_IMAGE + "_PENDING":
			return { ...state, finishimage: true }
		case UPLOAD_PROFILE_IMAGE + "_REJECTED":
			return { ...state, finishimage: false }
		case FAVORITE_PROJECT + "_FULFILLED":
			return {
				...state,
				userInfo: {
					...state.userInfo,
					favorite_project: payload.data.addfavoriteProject.favorite_project
				}
			}
		case FAVORITE_PROJECT + "_PENDING":
			return { ...state }
		case FAVORITE_PROJECT + "_REJECTED":
			return { ...state }
		case FOLLOW_USER + "_FULFILLED":
			return {
				...state,
				userInfo: {
					...state.userInfo,
					following: payload.data.followUser.following,
					follower: payload.data.followUser.follower
				}
			}
		case FOLLOW_USER + "_PENDING":
			return { ...state }
		case FOLLOW_USER + "_REJECTED":
			return { ...state }
		case WRITE_RATING + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case WRITE_RATING + "_PENDING":
			return {
				...state,
				finish: true
			}
		case WRITE_RATING + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case GET_RATING + "_FULFILLED":
			let rating = JSON.parse(payload.data.getRating.body).Items
			return {
				...state,
				rating,
				finish: false
			}
		case GET_RATING + "_PENDING":
			return {
				...state,
				finish: true
			}
		case GET_RATING + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case UPDATE_RATING + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case UPDATE_RATING + "_PENDING":
			return {
				...state,
				finish: true
			}
		case UPDATE_RATING + "_REJECTED":
			return {
				...state,
				finish: false
			}
		case SEND_EMAIL + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case SEND_EMAIL + "_PENDING":
			return {
				...state,
				finish: true
			}
		case SEND_EMAIL + "_REJECTED":
			return {
				...state,
				finish: false
			}
		default:
			return state
	}
}
